module.exports = __webpack_public_path__ + "static-appopensalud/img/openlegalpro_orange.13e40e3.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/openlegalpro_orange.svg
// module id = 1068
// module chunks = 120